export default __webpack_public_path__ + "static/media/planets.9943e268.txt";